import { createLink } from "@tanstack/react-router";
import { Button } from "@heroui/react";

export const ButtonLink = createLink(Button);
